import React, { useEffect, useState } from 'react'
import { useCreateDiscountMutation, useUpdateDiscountMutation } from '../Service/discountsApi';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import { discountValue } from '../initialValues';
import { DiscountsRoutes } from '../../../Router/path';
import { FormRenderGroupTypes } from '../../Shared/Components/FormRenderer/FormRenderGroup.types';
import SettingsIcon from "@mui/icons-material/Settings";
import InfoIcon from "@mui/icons-material/Info";
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout';
import { discountFields } from '../fields';
import { useGetBookingListQuery } from '../../Bookings/Service/extendedBookingsApi';
import { MultiAssign } from '../../Shared/Components/MultiAssign';
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import { useAssignBookingIdsToDiscountMutation, useGetDiscountWithBookingIdsQuery } from '../Service/extendedDiscountApi';
import AccordionCard from '../../Shared/Components/AccordionCard/AccordionCard';
import { Typography } from '@mui/material';


const CreateDiscount = () => {
    const [createdDiscountId, setCreatedDiscountId] = useState<number | null>(null);
    const [createDiscount, createStatus] = useCreateDiscountMutation();
    const [updateDiscount, updateStatus] = useUpdateDiscountMutation();

    const {
        data: bookingsPage,
        isLoading: bookingsLoading
    } = useGetBookingListQuery({ pageNumber: 1, pageSize: 100 });

    const {
        data: assignedData,
        isLoading: assignedLoading,
        refetch: refetchAssigned,
    } = useGetDiscountWithBookingIdsQuery(createdDiscountId!, {
        skip: !createdDiscountId,
    });

    const [selectedBookingIds, setSelectedBookingIds] = useState<number[]>([]);

    useEffect(() => {
        if (assignedData?.bookingIds) {
            setSelectedBookingIds(assignedData.bookingIds);
        }
    }, [assignedData]);

    const [assignBookings, { isLoading: isAssigning }] =
        useAssignBookingIdsToDiscountMutation();

    const mutationStatus = createdDiscountId ? updateStatus : createStatus;


    const entityForm = useEntityForm({
        initialData: discountValue,
        fields: discountFields,
        submitFn: (data) => {
            if (createdDiscountId) {
                return updateDiscount({ id: createdDiscountId, data }).unwrap();
            } else {
                return createDiscount(data).unwrap();
            }

        },
        redirectUrl: DiscountsRoutes.root,
        title: "Dodaj zniżkę",
        icon: <></>,
        backUrl: DiscountsRoutes.root,
        groupOrder: [
            FormRenderGroupTypes.basic,
            FormRenderGroupTypes.configuration,
        ],
        groupIcons: {
            Podstawowe: <InfoIcon sx={{ color: theme => theme.palette.primary.main }} />,
            Konfiguracja: <SettingsIcon sx={{ color: theme => theme.palette.primary.main }} />,
        },
        mutationStatus: mutationStatus,
        showSuccessBeforeRedirect: true,
        redirectDelay: 2000,
        onSuccessWithResponse: (response, shouldRedirect) => {
            if (!shouldRedirect) {
                setCreatedDiscountId(response.discountId);
            }
        },
    })
    return (
        <EntityFormLayout {...entityForm}>
            <AccordionCard title="Przypisz rezerwacje do zniżki" icon={<BookOnlineIcon fontSize="large" color="primary" />}>
                {createdDiscountId ? (
                    <MultiAssign

                        options={bookingsPage?.items || []}
                        loadingOptions={bookingsLoading || assignedLoading}
                        selectedIds={selectedBookingIds}
                        onChange={setSelectedBookingIds}
                        getOptionLabel={b =>
                            `${b.bookingDateFrom.slice(0, 10)} • ${b.offerName}`
                        }
                        getOptionValue={b => b.id}
                        onSave={async () => {
                            await assignBookings({ discountId: createdDiscountId, bookingIds: selectedBookingIds }).unwrap();
                            refetchAssigned();
                        }}
                        saving={isAssigning}
                        label="Wybierz rezerwacje"
                        placeholder="Zacznij pisać…"
                    />
                ) :
                    (<Typography color="text.secondary">
                        Rezerwacje  możesz dodać dopiero po zapisaniu rabatu.
                    </Typography>)}
            </AccordionCard>
        </EntityFormLayout>
    )
}

export default CreateDiscount